import React, { useContext, useState } from 'react';
import { Box, Heading, Text, Textarea, Button, useToast } from '@chakra-ui/react';
import { useStepperContext } from '../../contexts/StepperContext';

import axios from 'axios'; // Import Axios or your preferred HTTP client library


const Details = (props) => {

  const { userData, setUserData } = useStepperContext();
  const orderId = props.orderId;
  const toast = useToast();

  const handleChange = (event) => {
    const { name, value } = event.target;

    const wordCount = value.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount <= maxWordCount) {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: value }));
    } else {
      const truncatedValue = value.trim().split(/\s+/).slice(0, maxWordCount).join(' ');

      setUserData((prevUserData) => ({ ...prevUserData, [name]: truncatedValue }));

      alert(`Word limit exceeded. Please limit your response to ${maxWordCount} words.`);
    }
  };

  const handleTextareaChange = (event, name) => {
    const inputValue = event.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;
    const maxWordCount = getMaxWordCount(name);

    if (wordCount > maxWordCount) {
      toast({
        title: 'Word Limit Exceeded',
        description: `Please limit your input to ${maxWordCount} words.`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } else {
      setUserData((prevUserData) => ({ ...prevUserData, [name]: inputValue }));
    }
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   console.log(userData);
  // };

  const getMaxWordCount = (name) => {
    // Add your logic to determine the max word count based on the name of the textarea
    // For example:
    switch (name) {
      case 'p1':
        return 350;
      case 'p2':
        return 300;
      case 'p3':
        return 300;
      case 'p4':
        return 300;
        case 'p6':
        return 300;
      // Add cases for other text areas
      default:
        return 400;
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();// Log the form data before submitting

    const formData = {
      question1: userData.p1 || '',
      question2: userData.p2 || '',
      question3: userData.p3 || '',
      question4: userData.p4 || '',
      question5 : userData.p5 || '',
      question6 : userData.p6 || '',
    };
    try{
    const response = await axios.put('https://glb-api.onrender.com/appforms/apform2',{userData:formData, orderId : orderId, name: "PersonalDetails"}, {withCredentials:true});
    console.log(response);
    setUserData({});
    toast({
      title: 'Form Submitted',
      description: 'Your data has been submitted successfully.',
      status: 'success',
      duration: 5000,
      isClosable: true,
    });
  } catch (error) {
    console.error(error);
    toast({
      title: 'Error',
      description: 'An error occurred while submitting the form.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    })
  }
  };

  return (
    <Box mx="auto" mt="4">
      <Heading as="h1" size="xl" mb="4">
        Application Form 2
      </Heading>
      <form onSubmit={handleSubmit}>
        <Box mb="10">
          <Text p="5">
          1.	Give your brief intro - name (full), what have you studied - from where, which year, what are you doing currently (work wise) – what designation, where, since how long? In chronological order (300-350 words)          </Text>
          <Textarea
            name="p1"
            value={userData.p1 || ''}
            onChange={(event) => handleTextareaChange(event, 'p1')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
          2.	Which course do you wish to take up? Which university? Why this field (this should be sensible and convincing)? (200-300 words)
          </Text>
          <Textarea
            name="p2"
            value={userData.p2 || ''}
            onChange={(event) => handleTextareaChange(event, 'p2')}
            placeholder="Your answer"
          />
        </Box>
        <Box mb="6">
          <Text p="5">
          3.	Why Canada? Why this particular course and uni? Exact course name? Which factors appealed to you the most? (300 words)          </Text>
          <Textarea
            name="p3"
            value={userData.p3 || ''}
            onChange={(event) => handleTextareaChange(event, 'p3')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
          4.	Where do you see yourself after completion of your graduate studies and how does it relate to your long-term goal? When you plan to return to India after gaining substantial work experience – what will you do? (should be practical and very convincing) (200-250words)
          </Text>
          <Textarea
            name="p4"
            value={userData.p4 || ''}
            onChange={(event) => handleTextareaChange(event, 'p4')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
          5.	Do you have proper SDS compliance? (Tuitionfee, GIC etc.)
          </Text>
          <Textarea
            name="p5"
            value={userData.p5 || ''}
            onChange={(event) => handleTextareaChange(event, 'p5')}
            placeholder="Your answer"
          />
        </Box>

        <Box mb="6">
          <Text p="5">
          6.	Describe why you need this degree n why it is not available in India at Masters level. Align short term n long term goals here 300 words max
          </Text>
          <Textarea
            name="p6"
            value={userData.p6 || ''}
            onChange={(event) => handleTextareaChange(event, 'p6')}
            placeholder="Your answer"
          />
        </Box>

        <Button type="submit" colorScheme="blue">
          Submit
        </Button>



      </form>
    </Box>
  );
};

export default Details;
